import React, { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import { Dialog } from "@progress/kendo-react-dialogs";

import { TableHeader } from "../../../components/reusableItems/header";
import SearchIcon from "../../../assets/header/search.svg";
import { Reusable_table } from "../../../components/reusableItems/table";
import { ConfigData, DefaulSorting, data } from "./configData.js";
import {
    checkPermission,
    getUserPermission,
} from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { searchFilter } from "../../../components/reusableItems/filter/filter_helper";

import { REWARDS_OPERATORS_ADD, REWARDS_OPERATORS_DETAIL } from "../../../routes.js";
import { deleteRewardsOperator, fetchAllOperatorList } from "../../../store/rewardsOperator.js";
import { ShowDialog } from "../../../components/reusableItems/dialog.js";

export const RewardsOperatorList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showDelete, setShowDelete] = useState(false);
    const [selectedID,setSelectedID] = useState(null);
    const userPermissions = getUserPermission();
    const viewPermssion = checkPermission(
        userPermissions,
        "gamifications.view_campaign_operator_list"
    );
    console.log("thisisoermision", viewPermssion);
    const { loading, operator_list } = useSelector((state) => state.rewardsOperator);

    useEffect(() => {
        dispatch(fetchAllOperatorList());
    }, [])
    const handleCreateAction = () => {
        navigate(REWARDS_OPERATORS_ADD);
    };
    const icons = [
        {
            buttonName: "+ Add new",
            action: handleCreateAction,
            permission: true
        }
    ];
    const handleTableClick = (type, pk) => {
        // console.log(type, pk);
        if (type === "View Details") {
            navigate(`${REWARDS_OPERATORS_DETAIL}?id=${pk}`);
        }
        else if(type === "Edit"){
            navigate(`${REWARDS_OPERATORS_ADD}?id=${pk}`);
        }
        else {
            setShowDelete(true);
            setSelectedID(pk);
        }
    };
      const actionTrigger = () => {
        setShowDelete(false);
        dispatch(deleteRewardsOperator({id: selectedID})).then((res)=>{
            dispatch(fetchAllOperatorList());
        })
      }
    return (
        <>
            {viewPermssion ? (
                <div className="container">
                    <TableHeader title={"Locations"} icons={icons} />
                    {showDelete && (
                        <ShowDialog
                            title={"Please Confirm!"}
                            content={"Are you sure you want to delete?"}
                            cancelContent={"Cancel"}
                            confrimContent={"Delete"}
                            cancelbtn={() => setShowDelete(false)}
                            confrinbtn={actionTrigger}
                        />
                    )}
                    {loading ? (
                        <Loader
                            type="converging-spinner"
                            style={{
                                width: "100%",
                                height: "calc(100vh - 165px)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#ffffff4d",
                                position: "absolute",
                                zIndex: "999",
                            }}
                        />
                    ) : (
                        <Reusable_table
                            header={ConfigData}
                            data={operator_list}
                            pagination={true}
                            calculatePagi={true}
                            pageChangeLoading={false}
                            showRow={true}
                            defaultSorting={DefaulSorting}
                            handleAction={handleTableClick}
                            //   maxHeight={
                            //     search ? "calc(-282px + 100vh)" : "calc(100vh - 220px)"
                            //   }
                            maxWidth={"calc(100vw - 240px)"}
                        />
                    )}
                </div>
            ) : (
                <PermissionDeninedPage
                    height={"calc(100% - 76px)"}
                    title={"Sorry, You don't have permission to access this page!"}
                />
            )}
        </>
    );
};
